import { CardType } from '@backmarket/http-api/src/api-specs-payment/payment/payment.types'

const GOOGLE_PAY_TO_CARD_TYPE_MAPPING: Record<string, CardType> = {
  DEBIT: CardType.DEBIT,
  CREDIT: CardType.CREDIT,
  PREPAID: CardType.PREPAID,
  UNKNOWN: CardType.UNKNOWN,
}

export const normalizeGooglePayCardType = (type: string): CardType => {
  return GOOGLE_PAY_TO_CARD_TYPE_MAPPING[type] ?? CardType.UNKNOWN
}
